import Vue from "vue";
import Router from "vue-router";
import paths from "./paths";
// import NProgress from "nprogress";
// import "nprogress/nprogress.css";
// import store from "../store";
// import { Stream } from "stream";

Vue.use(Router);
var router = new Router({
  base: process.env.BASE_URL,
  mode: "history",
  linkActiveClass: "active",
  routes: paths,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

export default router;
